import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "./review.scss";

import review1 from "../../images/review1.jpg";
import review2 from "../../images/review2.jpg";
import review3 from "../../images/review3.jpg";
import review4 from "../../images/review4.jpg";
import review5 from "../../images/review5.jpg";
import review6 from "../../images/review6.jpg";
import review7 from "../../images/review7.jpg";
import review8 from "../../images/review8.jpg";
import review9 from "../../images/review9.jpg";

const Reviews = () => {
  const images = [
    review1,
    review2,
    review3,
    review4,
    review5,
    review6,
    review7,
    review8,
    review9,
  ];

  return (
    <div className="reviews-container">
      <h2>Отзывы наших клиентов</h2>

      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={20}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000 }}
        loop={true}
        className="reviews-slider"
        breakpoints={{
          320: { slidesPerView: 1, spaceBetween: 15 },
          768: { slidesPerView: 2, spaceBetween: 20 },
          1024: { slidesPerView: 3, spaceBetween: 30 },
        }}
      >
        {images.map((img, index) => (
          <SwiperSlide key={index}>
            <div className="review-card">
              <img src={img} alt={`review-${index}`} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Reviews;